import { useEffect, useState } from "react";
import api from "../lib/api";
import { Navbar } from "../components/Navbar";
import { CourseCard } from "../components/CourseCard";
import { Loader2, Search } from "lucide-react";

const CATEGORIES = ["All", "Pharmacology", "Pharmaceutics", "Medicinal Chemistry", "Pharmacognosy", "Clinical Pharmacy", "GPAT/NIPER Prep"];

export default function Courses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cat, setCat] = useState("All");
  const [q, setQ] = useState("");

  useEffect(() => {
    setLoading(true);
    api.get(`/courses${cat !== "All" ? `?category=${encodeURIComponent(cat)}` : ""}`)
      .then((res) => setCourses(res.data))
      .finally(() => setLoading(false));
  }, [cat]);

  const filtered = courses.filter((c) => c.title.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="min-h-screen bg-[#FAFAFC]">
      <Navbar />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10">
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
            Explore Courses
          </h1>
          <p className="text-slate-500 mt-2">Free and premium pharmacy courses with video lessons and PDF notes.</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-4 lg:items-center justify-between mb-8">
          <div className="flex flex-wrap gap-2">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                data-testid={`filter-${c.replace(/[^a-zA-Z]/g, "-").toLowerCase()}`}
                onClick={() => setCat(c)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                  cat === c ? "bg-teal-700 text-white" : "bg-white text-slate-600 border border-slate-200 hover:border-teal-400"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          <div className="relative w-full lg:w-64">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
            <input
              data-testid="course-search-input"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search courses..."
              className="w-full pl-9 pr-4 py-2.5 rounded-xl bg-white border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500/40"
            />
          </div>
        </div>

        {loading ? (
          <div className="grid place-items-center py-24"><Loader2 className="h-8 w-8 animate-spin text-teal-600" /></div>
        ) : filtered.length === 0 ? (
          <p className="text-center text-slate-500 py-24">No courses found.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filtered.map((c) => <CourseCard key={c.id} course={c} />)}
          </div>
        )}
      </div>
    </div>
  );
}
